import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Cookies, RequestURL, StaticMessage, RoutesAll } from 'src/app/Constants/app.constants';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { getGSTIN_LIST_body, getDownloadDoc_body } from 'src/app/common';
// import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { RestService } from 'src/app/Services/Rest/rest.service';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../shared/services/order.service';
import { TooltipDirective } from '@looorent/ng2-tooltip-directive';

declare var $: any;
declare var jQuery: any;
declare var require: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  userName: any;
  corporateName: any;
  isBorrowerDetailsPage: boolean = false;
  footerMsg: string = '';
  userProductsDetails:any;
  isShowdropdown: boolean = false;
  fullMenuShowing: boolean = false;
  isLenderPage:boolean = false;
  @ViewChild('mytooltip', { read: TooltipDirective }) mytooltip: TooltipDirective;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private authService: AuthenticationService, private toastr: ToastrService, private restService: RestService, private orderService: OrderService, private el: ElementRef) {

    this.authService.setCookies(Cookies.gstEmailAddress, "", 0);
    this.authService.setCookies(Cookies.gstusername, "", 0);
    this.authService.setCookies(Cookies.gstin, "", 0);

    if (this.authService.getCookies(Cookies.userName)) {
      this.userName = this.authService.getCookies(Cookies.userName);
    }
    if(this.authService.getCookies(Cookies.corporateName)){
      this.corporateName = this.authService.getCookies(Cookies.corporateName);
    }

    let url = window.location.pathname;
    this.isBorrowerDetailsPage = (url.toLowerCase().indexOf('getborrowerdetails') > -1);        
   
  }


  ngOnInit() {
    setTimeout( () => {
      if(this.authService.getCookies(Cookies.userName)){
        this.userName = this.authService.getCookies(Cookies.userName);
      }
      if(this.authService.getCookies(Cookies.corporateName)){
        this.corporateName = this.authService.getCookies(Cookies.corporateName);
      }
    },1500);
    this.footerMsg = '© ' +(new Date()).getFullYear() + ' All rights reserved.';
  }
  redirectToHomePage() {
    if (!this.isBorrowerDetailsPage) {
      //if lender page then we can call this function of emit change
      if(window.location.pathname == '/lender'){
        this.orderService.emitChangeEventForLogoClick("true");
      }
      this.authService.redirectToHomePage();
      if (window.screen.availWidth < 1360)
            this.fullMenuShowing = false;
    }
  }
  logout(){
        localStorage.setItem("entity_name","");
        localStorage.setItem("pan","");
        localStorage.setItem("gstin_id","");
        localStorage.setItem("entity_id","");
        localStorage.removeItem("my_pref");
    this.authService.logout();
  }

  hidePopUp(){
    this.mytooltip.hide();
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    this.authService.isTokenValid();
  }

  @HostListener('document:click', ['$event'])
  outSideClick(event: any) {
    event.stopPropagation();
    var container = $(".dropdown-menu-container");
    var dropDownContainer = $(".credit-hover-class");
    var productDropDownContainer = $("#solution");

    if (dropDownContainer.has(event.target).length === 0) {
      $('.credit-hover-class').removeClass('open');
    }
    if (container.has(event.target).length === 0 && this.isShowdropdown) {
      this.isShowdropdown = false;
    }
    if (productDropDownContainer.has(event.target).length === 0) {
      $('#solution').removeClass('open');
    }
    var navcontainer = $(".sidebar-toggle");
    if (navcontainer.has(event.target).length === 0) {
      if (this.fullMenuShowing) {
        this.fullMenuShowing = false;
      }
    }
  }

  openProductDropdown() {
    if (!this.userProductsDetails) {
      this.userProductsDetails = this.orderService.userProductsDetails;
    }
    if ($("#solution").hasClass("open")) {
      $("#solution").removeClass('open');
    } else {
      $("#solution").addClass('open');
    }
  }
  openUrl(url: any) {
    if ($("#solution").hasClass("open")) {
      $("#solution").removeClass('open');
    }
    window.open(url, "_blank");
  }
}

